import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Formik, Form, Field } from 'formik';
import * as Yup from 'yup';
import { actionCreators } from '../../store/modules/User';
import confirm from '../../utils/confirm';

class UserDelete extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  handleSave(values) {
    const { requestDelete } = this.props;

    confirm().then(() => requestDelete(null, values.password));
  }

  render() {
    return (
      <Formik onSubmit={values => this.handleSave(values)}
        ref={this.form}
        enableReinitialize
        validationSchema={Yup.object().shape({
          password: Yup.string()
            .min(6)
            .max(100)
            .required(),
        })}
        initialValues={{
          email: '',
          password: '',
        }}
        render={({ values, errors }) => (
          <Form>
            <div id="dataForm">
              <div className="row m-b-sm">
                <div className="col-sm-12">
                  <span className="page-title no-image">Dzēst Profilu</span>
                </div>
              </div>
              <div className="row p-l-md">
                <div className="col-md-12">
                  <div className="panel panel-default">
                    <div className="panel-heading" />
                    <div className="panel-body" id="scroller">
                      <div className="col-md-9">
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <div className="form-group form-group-lg label-static is-empty">
                              <label htmlFor="password" className="control-label font-bold">
                                Parole
                                <Field id="password"
                                  value={values.password || ''}
                                  name="password"
                                  type="password"
                                  autoFocus
                                  className={errors.password ? 'form-control error' : 'form-control'} />
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">
                            <button type="submit" className="gaas-tile-btn">
                              Dzēst
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        )} />
    );
  }
}

UserDelete.propTypes = {
  requestDelete: PropTypes.func.isRequired,
};

export default connect(
  null,
  dispatch => bindActionCreators(actionCreators, dispatch),
)(UserDelete);



// WEBPACK FOOTER //
// ./src/components/user/Delete.jsx